import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sample-card-related',
  templateUrl: './sample-card-related.component.html',
  styleUrls: ['./sample-card-related.component.scss']
})
export class SampleCardRelatedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
